import { Routes } from '@angular/router';
const ɵ0 = () => import("./modules/auth/auth.module.ngfactory").then(mod => mod.AuthModuleNgFactory), ɵ1 = () => import("./modules/admin/admin.module.ngfactory").then(mod => mod.AdminModuleNgFactory), ɵ2 = () => import("./modules/users/users.module.ngfactory").then(mod => mod.UsersModuleNgFactory);
const routes = [
    {
        path: 'auth',
        loadChildren: ɵ0
    },
    {
        path: 'admin',
        loadChildren: ɵ1
    },
    {
        path: 'user',
        loadChildren: ɵ2
    },
    { path: '**', redirectTo: 'auth' },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2 };
